import type { MaritimeForecastComponent, MaritimeForecastComponentOneOf3 } from "@/lib/api";

export const findText = (
  entries: MaritimeForecastComponent[],
  phenomenon: string,
): string | null => {
  const e = entries.find((en) => en.phenomenon === phenomenon);
  if (!e || e.type !== "text") return null;
  return e.message.nl ?? null;
};

export const findAdditionalText = (
  entries: MaritimeForecastComponent[],
  phenomenon: string,
): string | null => {
  const e = entries.find((en) => en.phenomenon === phenomenon);
  if (!e || e.type !== "text") return null;
  return e.additional_message?.nl ?? null;
};

export const findRange = (entries: MaritimeForecastComponent[], phenomenon: string) => {
  const e = entries.find((en) => en.phenomenon === phenomenon);
  if (!e || e.type !== "range") return null;
  return { min: e.min, max: e.max };
};

export const findValue = (
  entries: MaritimeForecastComponent[],
  phenomenon: string,
): number | null => {
  const e = entries.find((en) => en.phenomenon === phenomenon);
  if (!e || e.type !== "value") return null;
  return e.value;
};

export const findSeiches = (
  entries: MaritimeForecastComponent[],
): MaritimeForecastComponentOneOf3 | null => {
  const e = entries.find((en) => en.type === "seiches");
  if (!e || e.type !== "seiches") return null;
  return e;
};

/** Wind/gust row for maritime_forecast widget (NL). */
export const formatWindGustRowText = (entries: MaritimeForecastComponent[]): string => {
  const wind = findText(entries, "wind");
  const gust = findText(entries, "gust");
  if (!wind && !gust) return "geen";
  if (wind && !gust) return `${wind} (geen)`;
  if (!wind && gust) return gust;
  return `${wind} (${gust})`;
};

export const formatCloudWeatherRowText = (entries: MaritimeForecastComponent[]): string => {
  const cloud = findText(entries, "cloud") ?? "";
  const weather = findText(entries, "weather");
  return weather ? `${cloud}, ${weather}` : cloud;
};

export const formatVisibilityRowText = (entries: MaritimeForecastComponent[]): string =>
  findAdditionalText(entries, "visibility") ?? findText(entries, "visibility") ?? "";
